import React, { Component } from "react";
import axios from "axios";
import apiUrl from "../../../shared/config";
import makeAnimated from "react-select/animated";
import Select from "react-select";

class PublisherInput extends Component {
    state = {
        publishers: [],
        isLoading: true,
        isError: false
    };

    componentDidMount() {
        if (this.props.publishersArr && this.props.publishersArr.length > 0) {
            this.setState({ publishers: this.props.publishersArr, isLoading: false });
        } else {
            this.fetchPublishers();
        }
    }

    fetchPublishers = () => {
        axios.get(apiUrl + 'Publishers/getPublishers')
            .then(response => {
                this.setState({ publishers: response.data, isLoading: false });
            })
            .catch(error => {
                console.error('Error fetching publishers:', error);
                this.setState({ isError: true, isLoading: false });
            });
    };

    render() {
        const { publishers, isLoading, isError } = this.state;
        const { game_publishers_filter, gamePublishersUpdate, updatePage, closeGameDetails } = this.props;

        // Handle errors
        if (isError) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Error loading publishers. Please try again later."
                />
            );
        }

        // Handle loading state
        if (isLoading) {
            return (
                <Select
                    isMulti
                    isSearchable
                    options={[]}
                    placeholder="Loading publishers..."
                />
            );
        }

        // Handle normal state with data
        const options = publishers.map(publisher => ({
            value: publisher.game_publisher_id,
            label: publisher.game_publisher_name,
            color: '#9999FF'
        }));
        const animatedComponents = makeAnimated();

        const defaultOptions = game_publishers_filter.map(publisher_id => {
            return options.find(option => option.value === publisher_id) || { value: 0, label: "Invalid publisher id", color: '#9999FF' };
        });

        return (
            <Select
                isMulti
                isSearchable
                options={options}
                value={defaultOptions}
                closeMenuOnSelect={false}
                components={animatedComponents}
                placeholder="Select publishers to search by."
                onChange={(val) => {
                    const retArr = val ? val.map(e => e.value) : [];
                    console.log(retArr);
                    gamePublishersUpdate(retArr);
                    updatePage(0);
                    closeGameDetails(null);
                }}
            />
        );
    }
}

export default PublisherInput;
